function filter() {
    /* 
    Brands filter
    */
    const brandsBtn = document.querySelectorAll('.catalog__brands-link');
    const resetBtnWrapper = document.querySelector('.catalog__brands-item--reset');
    const products = document.querySelectorAll('.catalog__item');
    const productList = document.querySelector('.catalog__list');
    const emptyMessage = document.querySelector('.catalog__empty');

    if (brandsBtn.length > 0) {
        // Проверяем, есть ли сохраненный бренд в localStorage
        const savedBrand = localStorage.getItem('targetBrand');

        if (savedBrand) {
            // Устанавливаем data-targetBrand атрибут и фильтруем товары
            productList.dataset.targetBrand = savedBrand;
            filterProducts(savedBrand);

            // Добавляем активный класс сохраненному бренду
            brandsBtn.forEach(el => {
                if (el.dataset.brand.toLowerCase() === savedBrand) {
                    el.classList.add('active');
                }
            });

            resetBtnWrapper.style.display = 'block';
        }

        brandsBtn.forEach(el => {
            el.addEventListener('click', function(e) {
                // Отключаем стандартное поведение
                e.preventDefault();

                // Добавляем активный класс выбранному элементу
                brandsBtn.forEach(el => el.classList.remove('active'));
                this.classList.add('active');

                // Получаем значение дата-атрибута выбранного элемента
                const targetBrand = this.dataset.brand.toLowerCase();
                
                // Записываем в data-targetBrand и сохраняем в localStorage
                productList.dataset.targetBrand = targetBrand;
                localStorage.setItem('targetBrand', targetBrand);

                // Фильтруем список товаров по дата-атрибуту
                filterProducts(targetBrand);

                resetBtnWrapper.style.display = 'block';
            });
        });

        function filterProducts(targetBrand) {
            let hasActiveProducts = false;

            products.forEach(el => {
                el.classList.remove('active');
                el.style.display = 'none';
                if (el.dataset.brand.toLowerCase() === targetBrand) {
                    el.classList.add('active');
                    el.style.display = 'flex';
                    hasActiveProducts = true;
                }
            });

            // Проверяем, есть ли активные товары, и показываем или скрываем сообщение
            if (!hasActiveProducts) {
                emptyMessage.style.display = 'block';
            } else {
                emptyMessage.style.display = 'none';
            }
        }

        // Проверка при загрузке страницы
        if (savedBrand) {
            const hasActiveProducts = [...products].some(el => el.classList.contains('active'));
            if (!hasActiveProducts) {
                emptyMessage.style.display = 'block';
            } else {
                emptyMessage.style.display = 'none';
            }
        }

        //Сбрасываем фильтр при выходе из каталога
        // const navLinks = document.querySelectorAll('.nav__link');

        // navLinks.forEach(el=> {
        //     el.addEventListener('click', function(e) {
        //         // Отключаем стандартное поведение
        //         e.preventDefault();
        //         resetFilter (this);
        //     });
        // });
    }


    //Обработчик для кнопки сброса фильтра
    const resetBtn = document.querySelectorAll('.reset-filter');

    if (resetBtn.length > 0) {
        resetBtn.forEach(el=> {
            el.addEventListener('click', function(e) {
                // Отключаем стандартное поведение
                if(this.classList.contains('catalog__brands-link--reset')) {e.preventDefault();}
                
                // Удаляем сохраненный бренд из localStorage
                localStorage.removeItem('targetBrand');

                // Убираем активный класс у всех брендов
                brandsBtn.forEach(el => el.classList.remove('active'));

                // Делаем видимыми все товары
                products.forEach(el => {
                    el.classList.add('active');
                    el.style.display = 'flex';
                });

                // Скрываем сообщение об отсутствии товаров
                emptyMessage.style.display = 'none';

                resetBtnWrapper.style.display = 'none';
            });
        })
    }
}

export default filter;
